import { spacingMixin } from "@zillow/constellation";
import styled from "styled-components";
const Picture = styled.picture.withConfig({
  displayName: "Picture",
  componentId: "sc-1mn78nr-0"
})(["display:block;line-height:0;", ""], spacingMixin);
Picture.propTypes = {};
Picture.defaultProps = {};
export {
  Picture as default
};
